import type { ComponentCommonProps, Img, Video, ContainerProps } from '../../types/props.js'

export interface MediaPlayerItemProps {
  title: string
  name: string
  description: string
  img: Img
  mobileImg?: Img
  video?: Video
  youtubeId?: string
  isYouTube?: boolean
  quote?: string
  href?: string
}

export interface MediaPlayerMultiProps extends ComponentCommonProps, React.HTMLAttributes<HTMLDivElement> {
  data: {
    title?: string
    shape?: 'round' | 'square'
    items: MediaPlayerItemProps[]
    containerProps?: ContainerProps
  }
  onVideoPlayBtnClick?: (jIndex: number) => void
}
